<template>
  <div class="addbtncontent">
    <div class="add-btn" @click="addbtnClick">
      <span class="plus">+</span>
      <span>{{ value }}</span>
    </div>
    <span v-if="isShowSpan">请选择PDF格式文件上传</span>
  </div>
</template>
<script>
import API from "../../../../service/index";
import api from "../../../../service/modules/complaintApis";
import commonAPI from "../../../../utils/common";
import store from "../../../../store/index";
import moment from "moment";
// import eventBus from '../../../../main';
export default {
  props: {
    value: {
      type: String,
      default: () => {
        return "编辑附件";
      },
    },
    isShowSpan: {
      type: Boolean,
      default: () => {
        return true;
      },
    },
    isGoAndroidandIOS: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    monitorType: {
      type: String,
      default: () => {
        return "";
      },
    },
    year: {
      type: [String, Number],
      default: () => {
        return "";
      },
    },
    quarter: {
      type: [String, Number],
      default: () => {
        return "";
      },
    },
    area: {
      type: String,
      default: () => {
        return "";
      },
    },
    id: {
      type: String,
      default: () => {
        return "";
      },
    },
    submitAuth: {
      type: String,
      default: () => {
        return "";
      },
    },
  },
  data() {
    return {
      cosArg: null,
      cos: null,
      tempFile: [], //用来存 上传到服务器的文件
      tempFileList: [], //用来 存 已经上传的文件的 名字 大小 类型等数据
      temEvent: null,
    };
  },
  methods: {
    addbtnClick() {
       this.$emit("updateClick");
    },
  },
};
</script>
<style lang="less" scoped>
.addbtncontent {
  width: 100%;
  height: 100%;
  text-align: center;
  span {
    display: inline-block;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(204, 204, 204, 1);
    margin-top: 12px;
  }
}
.add-btn {
  width: 100%;
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(54, 178, 116, 1);
  border-radius: 3px;
  border: 1px dashed rgba(54, 179, 116, 1);
  .plus {
    line-height: 36px;
    padding-right: 4px;
    vertical-align: top;
  }
  span {
    margin-top: 0;
    line-height: 40px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(54, 178, 116, 1);
  }
}
</style>
